module.exports = __webpack_public_path__ + "img/xueqing.e339c779.png";